export default __webpack_public_path__ + "static/joko-app-screenshot-home-fr-08226bcea6fa244a993ae98cfca76c97.webp";